import { Locale } from '@ps-smart-cp/ppfw-client';

const areaUnitNameConfig = {
  squareMeter: new Map([
    [Locale.ja, '平米'],
    [Locale.en, 'Square Meter'],
  ]),
  tsubo: new Map([
    [Locale.ja, '坪'],
    [Locale.en, 'Tsubo'],
  ]),
  hectare: new Map([
    [Locale.ja, 'ヘクタール'],
    [Locale.en, 'Hectare'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { areaUnitNameConfig };
